import styles from "./SearchList.module.scss";
import { useState, Children } from "react";

const SearchList = ({
  selectedItems = [],
  onInputChange = (e) => {},
  onCheckboxChange = (e, item) => {},
  containerClassName = "",
  children,
}) => {
  const [filter, setFilter] = useState("");

  return (
    <div className={styles.container + " " + containerClassName}>
      <input
        className={styles.input}
        placeholder="Cerca..."
        value={filter}
        onChange={(e) => {
          setFilter(e.target.value);
          onInputChange(e);
        }}
      ></input>
      {children &&
        Children.map(children, (child, idx) => {
          return child.props.children
            .toLowerCase()
            .includes(filter.toLowerCase()) ? (
            <div key={idx} className={styles.item}>
              <input
                className={styles.checkbox}
                type="checkbox"
                checked={selectedItems.includes(child.props.value)}
                onChange={(e) => {
                  onCheckboxChange(e, child.props.value);
                }}
              ></input>
              <span className={styles.label}>{child.props.children}</span>
            </div>
          ) : null;
        })}
    </div>
  );
};

export default SearchList;
